var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { hoverMediaQuery, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { Flex } from '@finect/tabular-core/Flex';
export var Adviser = styled.div.withConfig({
  displayName: "partials__Adviser",
  componentId: "sc-kv2yjs-0"
})(["flex:1;margin-left:15px;text-align:left;> strong{display:block;}div{padding-top:0;padding-bottom:0;}a{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});
export var ProductName = styled.div.withConfig({
  displayName: "partials__ProductName",
  componentId: "sc-kv2yjs-1"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", " color:#fff;", ";"], getFont(0), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont(-1)));
export var ReviewTitle = styled.div.withConfig({
  displayName: "partials__ReviewTitle",
  componentId: "sc-kv2yjs-2"
})(["", " color:#fff;font-weight:600;", ";"], getFont(0, 'compact'), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont(-1, 'compact')));
export var AdviserCompany = styled.span.withConfig({
  displayName: "partials__AdviserCompany",
  componentId: "sc-kv2yjs-3"
})(["display:block;", " font-weight:500;color:", ";", ";"], getFont(-2, 'compact'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.uiDD;
}, maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont(-3, 'compact')));
export var AnswerBlock = styled.div.withConfig({
  displayName: "partials__AnswerBlock",
  componentId: "sc-kv2yjs-4"
})(["display:inline-block;@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){width:80%;}"]);
export var Answer = styled.div.withConfig({
  displayName: "partials__Answer",
  componentId: "sc-kv2yjs-5"
})(["position:relative;z-index:1;right:-12px;max-width:95%;padding:18px 24px;border-radius:", ";box-shadow:", ";margin:-33px 0 0 auto;background-color:#fff;color:", ";span img,span svg{border-radius:66px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.font;
});
export var AnsweredBy = styled(Answer.withComponent(Flex)).withConfig({
  displayName: "partials__AnsweredBy",
  componentId: "sc-kv2yjs-6"
})(["max-width:none;padding:", ";border-radius:", ";margin-top:", ";"], function (_ref6) {
  var preview = _ref6.preview;
  return preview ? '6px 12px 6px 6px' : '6px 24px 6px 6px';
}, function (_ref7) {
  var theme = _ref7.theme;
  return "66px ".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 66px");
}, function (_ref8) {
  var preview = _ref8.preview;
  return preview ? '-18px' : '-33px';
});
export var ReviewInfo = styled.div.withConfig({
  displayName: "partials__ReviewInfo",
  componentId: "sc-kv2yjs-7"
})(["display:inline-block;position:relative;width:100%;padding:", ";border-radius:", ";box-shadow:", ";background-color:", ";", " color:#fff;text-align:left;"], function (_ref9) {
  var preview = _ref9.preview;
  return preview ? '15px 24px 42px' : '15px 24px 54px';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.boxShadow;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.mainColor;
}, fontSmoothing);
export var Highlighted = styled.div.withConfig({
  displayName: "partials__Highlighted",
  componentId: "sc-kv2yjs-8"
})(["position:absolute;top:-14px;left:0;padding:4px 12px 2px 12px;background-color:#282933;border-radius:16px;font-size:14px;font-weight:500;z-index:1;"]);
export var ReviewBlock = styled.div.withConfig({
  displayName: "partials__ReviewBlock",
  componentId: "sc-kv2yjs-9"
})(["display:flex;align-items:flex-end;flex-direction:column;min-width:400px;padding:24px;", " white-space:normal;transition:transform 0.15s ease;", " ", " ", " ", " ", " ", " ", ";"], getFont(-1), maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    min-width: 320px;\n  "]))), maxMediaQueries.bigScreen(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    min-width: 360px;\n  "]))), hoverMediaQuery(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    &:hover {\n      transform: translateY(-3px);\n    }\n  "]))), function (_ref13) {
  var quote = _ref13.quote,
    voces = _ref13.voces;
  return (quote || voces) && "\n    min-width: 340px !important;\n    width: 340px !important;\n\n    ".concat(ReviewTitle, " {\n        font-weight: 500;\n    }\n\n    ").concat(ReviewInfo, " {\n      padding: 15px 24px 42px;\n    }\n\n    ").concat(AnsweredBy, " {\n      width: 100%;\n\n      > span {\n        border: 6px solid #fff;\n        border-radius: 66px;\n        background: #ffffff;\n        mix-blend-mode: normal;\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      }\n\n      > img {\n        max-height: 45px;\n        max-width: 100px;\n      }\n    }\n  ");
}, function (_ref14) {
  var quote = _ref14.quote;
  return quote && "\n    ".concat(AnsweredBy, " {\n      padding: 0px 12px 0px 0px;\n\n      > img {\n        margin-left: 24px;\n      }\n    }\n\n    ").concat(Adviser, " {\n      margin-left: 8px;\n    }\n  ");
}, function (_ref15) {
  var voces = _ref15.voces,
    theme = _ref15.theme;
  return voces && "\n    ".concat(ReviewInfo, " {\n      background-color: ").concat(theme.colors.accent3, ";\n      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);\n    }\n\n    ").concat(AnsweredBy, " {\n      padding: 0px 0px 0px 12px;\n      border-radius: ").concat(theme.borderRadius, " 66px 66px ").concat(theme.borderRadius, ";\n      flex-direction: row-reverse;\n\n      > img {\n        margin-right: 12px;\n      }\n    }\n\n    ").concat(Adviser, " {\n      margin-right: 12px;\n      text-align: right;\n    }\n  ");
}, function (_ref16) {
  var highlighted = _ref16.highlighted,
    theme = _ref16.theme;
  return highlighted && "\n    ".concat(ReviewInfo, " {\n      padding-top: 24px;\n      background-color: ").concat(theme.colors.accent3, ";\n      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);\n    }\n\n    ").concat(AnsweredBy, " {\n      img {\n        border: 3px solid ").concat(theme.colors.accent3, ";\n      }\n    }\n\n  ");
});